import { GeneralActions } from '../../../../../actions';

const Mutations = Object.freeze({
	SET_FILTERS: 'projectSettings/connectors/connectorFilters/SET_FILTERS',
	SET_SELECTED_CONNECTOR:
		'projectSettings/connectors/connectorFilters/SET_SELECTED_CONNECTOR',
});

export const Actions = Object.freeze({
	CLEAR: 'projectSettings/connectors/connectorFilters/CLEAR',
	LOAD_SELECTED_CONNECTOR:
		'projectSettings/connectors/connectorFilters/LOAD_SELECTED_CONNECTOR',
	LOAD: 'projectSettings/connectors/connectorFilters/LOAD',
	ADD: 'projectSettings/connectors/connectorFilters/ADD',
	UPDATE: 'projectSettings/connectors/connectorFilters/UPDATE',
	DELETE: 'projectSettings/connectors/connectorFilters/DELETE',
});

export const Getters = Object.freeze({
	SELECTED_CONNECTOR:
		'projectSettings/connectors/connectorFilters/SELECTED_CONNECTORS',
	PARENT_FILTERS:
		'projectSettings/connectors/connectorFilters/PARENT_FILTERS',
	CHILD_FILTERS: 'projectSettings/connectors/connectorFilters/CHILD_FILTERS',
});

import dataService from '../../../../../../services/data/projectSettingsService';
import { gridViewConnectorFilterType } from '../../../../../../enums/gridViewConnectorFilterType';
export default {
	state: {
		filters: [],
		selectedConnector: null,
	},
	mutations: {
		[Mutations.SET_SELECTED_CONNECTOR](state, item) {
			state.selectedConnector = item;
		},
		[Mutations.SET_FILTERS](state, items) {
			state.filters = items;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_FILTERS, []);
				commit(Mutations.SET_SELECTED_CONNECTOR, null);
				resolve();
			});
		},

		[Actions.LOAD_SELECTED_CONNECTOR]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_SELECTED_CONNECTOR, item);
				dispatch(GeneralActions.LOADING, false);
				resolve();
			});
		},

		[Actions.LOAD]({ commit, dispatch }, selectedConnector) {
			return new Promise((resolve) => {
				dataService
					.getGridViewConnectorFiltersByConnector(selectedConnector)
					.then((resp) => {
						commit(Mutations.SET_FILTERS, resp.data);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve();
					});
			});
		},

		[Actions.ADD]({ commit, dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.addGridViewConnectorFilters(item)
					.then((resp) => {
						let filters = state.filters;
						filters.push(resp.data);
						commit(Mutations.SET_FILTERS, filters);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.UPDATE]({ commit, dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateGridViewConnectorFilters(item)
					.then((resp) => {
						let filters = state.filters;
						let index = filters.findIndex((x) => x.Id == item.Id);
						if (index >= 0) filters.splice(index, 1, resp.data);
						commit(Mutations.SET_FILTERS, filters);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.DELETE]({ commit, dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteGridViewConnectorFilters(item)
					.then(() => {
						let filters = state.filters;
						let index = filters.findIndex((x) => x.Id == item.Id);
						if (index >= 0) filters.splice(index, 1);
						commit(Mutations.SET_FILTERS, filters);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
	},
	getters: {
		[Getters.PARENT_FILTERS]: (state) => {
			if (state.filters && state.filters.length > 0) {
				let items = state.filters.filter(
					(x) =>
						x.GridViewConnectorFilterType ==
						gridViewConnectorFilterType.Parent
				);
				return JSON.parse(JSON.stringify(items));
			}
			return [];
		},
		[Getters.CHILD_FILTERS]: (state) => {
			if (state.filters && state.filters.length > 0) {
				let items = state.filters.filter(
					(x) =>
						x.GridViewConnectorFilterType ==
						gridViewConnectorFilterType.Child
				);
				return JSON.parse(JSON.stringify(items));
			}
			return [];
		},
		[Getters.SELECTED_CONNECTOR]: (state) => {
			if (!state.selectedConnector) return null;
			return JSON.parse(JSON.stringify(state.selectedConnector));
		},
	},
};
